import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {UnitModel} from '../../unit/unit.model';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExecutorCoOwnedUnitListService {

  constructor(
    private http: HttpClient
  ) { }

  public getUnits(executorId: number) {
    const httpParams = new HttpParams().set('expand', 'activeExecutorBillingId');

    return this.http.get<UnitModel[]>(
      environment.apiBasepoint + 'executor/' + executorId.toString(10) + '/co-owned-unit',
      {
        params: httpParams,
        observe: 'body'
      }
    );
  }
}
